var map = {
	"./add-recipient.svg": 746,
	"./alipay.svg": 747,
	"./amex.svg": 748,
	"./app-logout.svg": 749,
	"./arrow.svg": 750,
	"./bank-deposit.svg": 751,
	"./bank.svg": 752,
	"./calculator.svg": 753,
	"./calendar.svg": 754,
	"./check.svg": 755,
	"./checkbox-off.svg": 756,
	"./checkbox-on.svg": 757,
	"./chevron-back.svg": 758,
	"./chevron-down.svg": 759,
	"./close.svg": 760,
	"./cloud.svg": 761,
	"./credit-card.svg": 762,
	"./cross.svg": 763,
	"./default.svg": 764,
	"./delete.svg": 765,
	"./diners.svg": 766,
	"./discover.svg": 767,
	"./done-filled.svg": 768,
	"./download.svg": 769,
	"./e-mail.svg": 770,
	"./edit.svg": 771,
	"./elo.svg": 772,
	"./email-contact.svg": 773,
	"./email-notify.svg": 774,
	"./email.svg": 775,
	"./error.svg": 776,
	"./eye.svg": 777,
	"./facebook.svg": 778,
	"./fail.svg": 779,
	"./file.svg": 780,
	"./follow.svg": 781,
	"./forward.svg": 782,
	"./hipercard.svg": 783,
	"./how-it-works.svg": 784,
	"./image.svg": 785,
	"./info.svg": 786,
	"./information.svg": 787,
	"./instagram.svg": 788,
	"./jcb.svg": 789,
	"./linkedin.svg": 790,
	"./location.svg": 791,
	"./maestro-old.svg": 792,
	"./maestro.svg": 793,
	"./mastercard-old.svg": 794,
	"./mastercard.svg": 795,
	"./media-notify.svg": 796,
	"./money-delivery.svg": 797,
	"./more.svg": 798,
	"./new-recipient.svg": 799,
	"./panding.svg": 800,
	"./paypal.svg": 801,
	"./phone-call.svg": 802,
	"./phone-notify.svg": 803,
	"./phone.svg": 804,
	"./post-notify.svg": 805,
	"./post.svg": 806,
	"./present.svg": 807,
	"./present_deactive.svg": 808,
	"./process.svg": 809,
	"./profile.svg": 810,
	"./recipients.svg": 811,
	"./refresh.svg": 812,
	"./search.svg": 813,
	"./security-code.svg": 814,
	"./security.svg": 815,
	"./settings.svg": 816,
	"./sms-notify.svg": 817,
	"./sms.svg": 818,
	"./success.svg": 819,
	"./support.svg": 820,
	"./transaction-list.svg": 821,
	"./transfer-money.svg": 822,
	"./twitter.svg": 823,
	"./uk.svg": 824,
	"./unionpay.svg": 825,
	"./users.svg": 826,
	"./verve.svg": 827,
	"./visa.svg": 828,
	"./waiting.svg": 829,
	"./warning.svg": 830,
	"./zoom.svg": 831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 745;